import { Box, Typography } from '@mui/material';
import BasePageContainer from 'components/views/RegisterValidationComp/PageSuccessAndErrors/BasePageContainer';

import { ReactComponent as IcChatWhatsapp } from 'assets/icons/ic-chat-whatsapp.svg';
import { ReactComponent as IcIturinInstallationDone } from 'assets/icons/ic-iturin-confused.svg';

const BirthDateError = () => {
    return (
        <BasePageContainer>
            <Box sx={{
                display: 'grid',
                textAlign: 'center',
                paddingBottom: '1rem',
                justifyItems: 'center'
            }}>
                <Box sx={{
                    'svg': {
                        display: { xs: 'none', md: 'block' }
                    }
                }}>
                    <IcIturinInstallationDone />
                </Box>
                <Typography fontWeight={700} lineHeight='1.2' textTransform='uppercase' textAlign='center' maxWidth='fit-content' sx={{
                    fontSize: { xs: '1.375rem', md: '1.875rem' },
                    paddingTop: '.875rem',
                    'b': {
                        color: 'primary.light'
                    }
                }}>
                    OPS... NÃO FOI POSSÍVEL SEGUIR COM A VALIDAÇÃO!
                </Typography>

                <Typography margin='0 auto' lineHeight='1.1' sx={{
                    maxWidth: { xs: '20.8rem', md: '26.5rem' },
                    padding: '.75rem 0 1.25rem',
                    fontSize: { xs: '.9375rem', md: '1rem' }
                }}>
                    Pedimos que entre em contato através de nossos canais abaixo, ou através do seu corretor:
                </Typography>

                <Box>
                    <a href='https://api.whatsapp.com/send/?phone=551136169000' target='blank'>
                        <IcChatWhatsapp />
                    </a>
                    <Typography lineHeight='2.5' fontSize='1.125rem' sx={{
                        'span': {
                            fontSize: '.9375rem',
                            paddingBottom: '.75rem',
                            borderBottom: '2px solid',
                            borderColor: 'primary.light'
                        },
                    }}>
                        <span>opção: Reagendamento</span>
                        <br />
                        <b>CENTRAL DE ATENDIMENTO</b>
                    </Typography>
                    <Box display='flex' justifyContent='space-between' paddingBottom='1rem' sx={{
                        width: { xs: '20rem', md: '23rem' }
                    }}>
                        <Typography fontSize='.75rem' lineHeight='1.3' sx={{
                            'b': {
                                fontSize: '1rem',
                            }
                        }}>
                            São Paulo
                            <br />
                            <b>(11) 3616-9000</b>
                            <br />
                            Opção 1
                        </Typography>
                        <Typography fontSize='.75rem' lineHeight='1.3' sx={{
                            'b': {
                                fontSize: '1rem',
                            }
                        }}>
                            Outras regiões
                            <br />
                            <b>0800 774 2000</b>
                            <br />
                            Opção 1
                        </Typography>
                    </Box>
                    <Typography fontSize='1rem' lineHeight='1.3'>
                        Segunda à sexta: <b>8h às 18h</b>
                        <br />
                        Sábado: <b>8h às 14h</b>
                    </Typography>
                </Box>
            </Box>
        </BasePageContainer>
    );
}

export default BirthDateError;